import React, { Component } from "react";
import { Form, Col, Row, Button, Table, InputGroup } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import "../../assets/styles/RetailPortal.css";

function RetailDiscountCouponDetail({ props, state, ...rest }) {
  const {
    handleActiveChange,
    handleDiscountType,
    handleFlatChange,
    handleOnChange,
    handlePercentageCapChange,
    handlePercentageChange,
    handlePlan,
    handlePlanType,
    handleAssignCouponsToAllPlans,
  } = rest;
  let {
    code,
    active,
    error,
    plans,
    start_date,
    expiry_date,
    isSubmitting,
    hasErrors,
    percentage,
    percentageCap,
    type,
    flat,
    planType,
    quantity,
  } = state;
  return (
    // <Form onSubmit={handleSubmit} className="form-container">
    <>
      <Form.Group controlId="code">
        <Form.Label>Code</Form.Label>
        <Form.Control
          onChange={handleOnChange}
          value={code.toUpperCase()}
          type="text"
          name="code"
        />
        <Form.Text className={"error-label"}>{error["code"]}</Form.Text>
      </Form.Group>
      <fieldset className="dicount_value_box">
        <legend>Discount Type:</legend>
        <div key={`inline-radio`} className="mb-3">
          <Form.Check
            inline
            name="flat"
            checked={type == "flat"}
            onChange={handleDiscountType}
            value="flat"
            label="Flat"
            type="radio"
            id="flat"
          />
          <Form.Check
            inline
            name="percentage"
            checked={type == "percentage"}
            onChange={handleDiscountType}
            value="percentage"
            label="Percentage"
            type="radio"
            id="percentage"
          />
        </div>
        {type == "flat" && (
          <Form.Group controlId="flat">
            <Form.Label>Flat Discount(Rs)</Form.Label>
            <Form.Control
              onChange={handleFlatChange}
              value={flat}
              type="number"
            />
          </Form.Group>
        )}
        {type == "percentage" && (
          <>
            <Form.Group controlId="percentage">
              <Form.Label>Percentage Discount(%)</Form.Label>
              <Form.Control
                onChange={handlePercentageChange}
                value={percentage}
                type="number"
              />
            </Form.Group>
            <Form.Group controlId="percentageCap">
              <Form.Label>Percentage Discount Cap(Rs)</Form.Label>
              <Form.Control
                onChange={handlePercentageCapChange}
                value={percentageCap}
                type="number"
              />
            </Form.Group>
          </>
        )}
      </fieldset>
      <Form.Group controlId="start_date">
        <Form.Label>Start Date</Form.Label>
        <Form.Control
          onChange={handleOnChange}
          value={start_date}
          type="date"
        />
      </Form.Group>
      <Form.Group controlId="expiry_date">
        <Form.Label>Expiry Date</Form.Label>
        <Form.Control
          onChange={handleOnChange}
          value={expiry_date}
          type="date"
        />
      </Form.Group>
      <Form.Group controlId="planType">
        <Form.Check
          inline
          name="all"
          checked={planType == "all"}
          onChange={handlePlanType}
          value="all"
          label="All"
          type="radio"
          id="planType"
        />
        <Form.Check
          inline
          name="multiple"
          checked={planType == "multiple"}
          onChange={handlePlanType}
          value="multiple"
          label="Choose Specific Plans"
          type="radio"
          id="planType"
        />
      </Form.Group>
      {planType == "all" && (
        <Form.Group controlId="quantity">
          <Form.Label>Coupon Quantity</Form.Label>
          <Form.Control
            onChange={handleAssignCouponsToAllPlans}
            type="number"
            value={quantity}
          />
        </Form.Group>
      )}
      {planType == "multiple" && (
        <>
          <Form.Label>Plans</Form.Label>
          {plans.map((plan, id) => (
            <Form.Group controlId={plan._id} key={id}>
              <Form.Label>{plan.description}</Form.Label>
              <Form.Control
                onChange={(event) => {
                  handlePlan(event, plan);
                }}
                value={plan.quantity}
                type="number"
              />
              {/* </Form.Control> */}
            </Form.Group>
          ))}
        </>
      )}

      <Form.Group>
        <Form.Check
          onChange={handleActiveChange}
          checked={active}
          type="checkbox"
          label="Active"
        />
      </Form.Group>
      <Button
        disabled={isSubmitting || hasErrors}
        className="submit-button"
        variant="primary"
        type="submit"
      >
        Submit
      </Button>
    </>
  );
}
export default withRouter(RetailDiscountCouponDetail);
